import { useSyncExternalStore } from 'react';
import { RefreshCw } from 'lucide-react';
import { updateStore } from './updateStore';

/**
 * Fixed, unobtrusive, never automatic: Reload now, or Later. On a phone it
 * sits above the bottom bar and the corner column (CornerStack, 2026-10-28)
 * rather than over them.
 */
export function UpdateBanner() {
  const { apply, dismissed } = useSyncExternalStore(updateStore.subscribe, updateStore.getSnapshot, updateStore.getSnapshot);
  if (!apply || dismissed) return null;
  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-50 max-lg:bottom-[calc(var(--corner-base,1rem)+var(--corner-lift,0px)+var(--corner-stack-height,0px)+0.5rem)] flex w-[min(92vw,40rem)] -translate-x-1/2 items-center gap-3 rounded-xl border border-safety-500/40 bg-graphite-900 px-4 py-3 text-sm text-graphite-100 shadow-xl"
    >
      <RefreshCw className="h-4 w-4 shrink-0 text-safety-400" aria-hidden />
      <span className="min-w-0 flex-1">A new version of DemoOps is ready. Reload when convenient — nothing will reload on its own.</span>
      <button
        type="button"
        onClick={() => updateStore.dismiss()}
        className="rounded-lg px-3 py-1.5 text-graphite-300 hover:bg-graphite-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-safety-500"
      >
        Later
      </button>
      <button
        type="button"
        onClick={() => apply()}
        className="rounded-lg bg-safety-500 px-3 py-1.5 font-semibold text-white hover:bg-safety-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-safety-300"
      >
        Reload
      </button>
    </div>
  );
}
